import styled from 'styled-components';

import { min_width_md } from '../../../theme/breakpoints';
import { color } from '../../../theme/functions';
import { THEME_DENTOLO, THEME_PETOLO } from '../../../shared';

import { Input, Paper } from '../../../components/common';

const fontColor = ({ theme }) => {
  const { name, colors } = theme || {};
  switch (name) {
    case THEME_DENTOLO:
      return colors?.main_green;
    case THEME_PETOLO:
      return colors?.main_orange;
    default:
      return colors?.main_green;
  }
};

export const StyledReferralCoverImageContainer = styled(Paper)`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ special }) => (special ? '0.5rem' : '1rem')};
  padding: 0;
  background-color: ${({ special }) => (special ? 'transparent' : color('white'))};

  > img {
    border-radius: 5px;
    width: ${({ special }) => (special ? 'calc(100% + 1rem)' : '100%')};
    max-width: ${({ special }) => (special ? 'calc(100% + 1rem)' : '100%')};
  }

  @media (min-width: ${min_width_md}) {
    margin-bottom: 1.5rem;
  }
`;
export const StyledReferralCoverImageContainerSm = styled(StyledReferralCoverImageContainer)`
  display: flex;

  @media (min-width: ${min_width_md}) {
    display: none;
  }
`;

export const StyledReferralCoverImageContainerLg = styled(StyledReferralCoverImageContainer)`
  display: none;

  @media (min-width: ${min_width_md}) {
    display: flex;
  }
`;

export const StyledPetReferralImageWrapperLg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  width: 100%;
  height: 290px;

  > img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const StyledPresentImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const StyledReferralGiftText = styled.h4`
  text-align: center;
  font-size: 1.25rem;

  @media (min-width: ${min_width_md}) {
    font-size: 1.5rem;
  }
`;

export const StyledReferralCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledReferralInput = styled(Input)`
  border: 1px solid ${color('light_gray')};
  margin-bottom: 1em;
`;

export const StyledReferralCard = styled(Paper)`
  & + & {
    margin-top: 1rem;
  }
`;

export const StyledReferralItemContainer = styled.div`
  display: flex;
  margin-bottom: 0.5rem;

  @media (min-width: ${min_width_md}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
  }
`;
export const StyledReferralItemIndexContainer = styled.div`
  margin: 0 1.2rem 0 0;
  border-radius: 50%;
  font-size: 1.25rem;
  width: 24px;
  height: 24px;
  background-color: ${color('main_blue')};
  color: ${fontColor};
  text-align: center;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const StyledReferralItemIndex = styled.span`
  position: relative;
  bottom: 1.5px;
`;

export const StyledReferralItemDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
`;

export const StyledReferralItemDescription = styled.div`
  color: ${color('main_blue')};
  font-size: 1rem;
  line-height: 20px;
  font-weight: 450;

  @media (min-width: ${min_width_md}) {
    font-size: 1.25rem;
    line-height: 24px;
  }
`;

export const StyledSocialLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  align-items: center;
`;

export const StyledSocialGroup = styled.div`
  display: flex;
  width: 60%;
  justify-content: space-between;
`;

export const StyledSocialImg = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
`;
